export default __webpack_public_path__ + "static/media/devConnector.d7a97a09.png";